module.exports = __webpack_public_path__ + "static/media/table2.9fbf0e29.png";